/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeTaskFailureCapsuleActionDto,
  ApiEnvelopeTaskFailureCapsuleDetailDto,
  ApiEnvelopeTaskFailureCapsuleDto,
  ApiEnvelopeTaskFailureCapsuleListDto,
  ApiEnvelopeTaskFailureCapsuleStatusDto,
  TaskFailureCapsuleAdminListParams
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type taskFailureCapsuleAdminListResponse200 = {
  data: ApiEnvelopeTaskFailureCapsuleListDto
  status: 200
}

export type taskFailureCapsuleAdminListResponse401 = {
  data: ApiEnvelopeTaskFailureCapsuleListDto
  status: 401
}

export type taskFailureCapsuleAdminListResponseSuccess = (taskFailureCapsuleAdminListResponse200) & {
  headers: Headers;
};
export type taskFailureCapsuleAdminListResponseError = (taskFailureCapsuleAdminListResponse401) & {
  headers: Headers;
};

export type taskFailureCapsuleAdminListResponse = (taskFailureCapsuleAdminListResponseSuccess | taskFailureCapsuleAdminListResponseError)

export const getTaskFailureCapsuleAdminListUrl = (params?: TaskFailureCapsuleAdminListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/vektor/admin/task-capsules?${stringifiedParams}` : `/api/vektor/admin/task-capsules`
}

export const useTaskFailureCapsuleAdminListHook = (): (params?: TaskFailureCapsuleAdminListParams, options?: RequestInit) => Promise<taskFailureCapsuleAdminListResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: TaskFailureCapsuleAdminListParams, options?: RequestInit) => {

        return customFetcher(getTaskFailureCapsuleAdminListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type taskFailureCapsuleAdminGetResponse200 = {
  data: ApiEnvelopeTaskFailureCapsuleDetailDto
  status: 200
}

export type taskFailureCapsuleAdminGetResponse401 = {
  data: ApiEnvelopeTaskFailureCapsuleDetailDto
  status: 401
}

export type taskFailureCapsuleAdminGetResponse404 = {
  data: ApiEnvelopeTaskFailureCapsuleDetailDto
  status: 404
}

export type taskFailureCapsuleAdminGetResponseSuccess = (taskFailureCapsuleAdminGetResponse200) & {
  headers: Headers;
};
export type taskFailureCapsuleAdminGetResponseError = (taskFailureCapsuleAdminGetResponse401 | taskFailureCapsuleAdminGetResponse404) & {
  headers: Headers;
};

export type taskFailureCapsuleAdminGetResponse = (taskFailureCapsuleAdminGetResponseSuccess | taskFailureCapsuleAdminGetResponseError)

export const getTaskFailureCapsuleAdminGetUrl = (capsuleId: string,) => {




  return `/api/vektor/admin/task-capsules/${capsuleId}`
}

export const useTaskFailureCapsuleAdminGetHook = (): (capsuleId: string, options?: RequestInit) => Promise<taskFailureCapsuleAdminGetResponse> => {

      const customFetcher = useSfetchMutator();
      return (capsuleId: string, options?: RequestInit) => {

        return customFetcher(getTaskFailureCapsuleAdminGetUrl(capsuleId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type taskFailureCapsuleAdminDeleteResponse200 = {
  data: ApiEnvelopeTaskFailureCapsuleActionDto
  status: 200
}

export type taskFailureCapsuleAdminDeleteResponse401 = {
  data: ApiEnvelopeTaskFailureCapsuleActionDto
  status: 401
}

export type taskFailureCapsuleAdminDeleteResponse404 = {
  data: ApiEnvelopeTaskFailureCapsuleActionDto
  status: 404
}

export type taskFailureCapsuleAdminDeleteResponseSuccess = (taskFailureCapsuleAdminDeleteResponse200) & {
  headers: Headers;
};
export type taskFailureCapsuleAdminDeleteResponseError = (taskFailureCapsuleAdminDeleteResponse401 | taskFailureCapsuleAdminDeleteResponse404) & {
  headers: Headers;
};

export type taskFailureCapsuleAdminDeleteResponse = (taskFailureCapsuleAdminDeleteResponseSuccess | taskFailureCapsuleAdminDeleteResponseError)

export const getTaskFailureCapsuleAdminDeleteUrl = (capsuleId: string,) => {




  return `/api/vektor/admin/task-capsules/${capsuleId}`
}

export const useTaskFailureCapsuleAdminDeleteHook = (): (capsuleId: string, options?: RequestInit) => Promise<taskFailureCapsuleAdminDeleteResponse> => {

      const customFetcher = useSfetchMutator();
      return (capsuleId: string, options?: RequestInit) => {

        return customFetcher(getTaskFailureCapsuleAdminDeleteUrl(capsuleId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type taskFailureCapsuleAdminStatusResponse200 = {
  data: ApiEnvelopeTaskFailureCapsuleStatusDto
  status: 200
}

export type taskFailureCapsuleAdminStatusResponse401 = {
  data: ApiEnvelopeTaskFailureCapsuleStatusDto
  status: 401
}

export type taskFailureCapsuleAdminStatusResponseSuccess = (taskFailureCapsuleAdminStatusResponse200) & {
  headers: Headers;
};
export type taskFailureCapsuleAdminStatusResponseError = (taskFailureCapsuleAdminStatusResponse401) & {
  headers: Headers;
};

export type taskFailureCapsuleAdminStatusResponse = (taskFailureCapsuleAdminStatusResponseSuccess | taskFailureCapsuleAdminStatusResponseError)

export const getTaskFailureCapsuleAdminStatusUrl = () => {




  return `/api/vektor/admin/task-capsules/status`
}

export const useTaskFailureCapsuleAdminStatusHook = (): ( options?: RequestInit) => Promise<taskFailureCapsuleAdminStatusResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getTaskFailureCapsuleAdminStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type taskFailureCapsuleAdminCaptureResponse200 = {
  data: ApiEnvelopeTaskFailureCapsuleDto
  status: 200
}

export type taskFailureCapsuleAdminCaptureResponse401 = {
  data: ApiEnvelopeTaskFailureCapsuleDto
  status: 401
}

export type taskFailureCapsuleAdminCaptureResponse404 = {
  data: ApiEnvelopeTaskFailureCapsuleDto
  status: 404
}

export type taskFailureCapsuleAdminCaptureResponseSuccess = (taskFailureCapsuleAdminCaptureResponse200) & {
  headers: Headers;
};
export type taskFailureCapsuleAdminCaptureResponseError = (taskFailureCapsuleAdminCaptureResponse401 | taskFailureCapsuleAdminCaptureResponse404) & {
  headers: Headers;
};

export type taskFailureCapsuleAdminCaptureResponse = (taskFailureCapsuleAdminCaptureResponseSuccess | taskFailureCapsuleAdminCaptureResponseError)

export const getTaskFailureCapsuleAdminCaptureUrl = (botId: string,) => {




  return `/api/vektor/admin/task-capsules/capture/${botId}`
}

export const useTaskFailureCapsuleAdminCaptureHook = (): (botId: string, options?: RequestInit) => Promise<taskFailureCapsuleAdminCaptureResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getTaskFailureCapsuleAdminCaptureUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type taskFailureCapsuleAdminDownloadResponse200 = {
  data: Blob
  status: 200
}

export type taskFailureCapsuleAdminDownloadResponseSuccess = (taskFailureCapsuleAdminDownloadResponse200) & {
  headers: Headers;
};
;

export type taskFailureCapsuleAdminDownloadResponse = (taskFailureCapsuleAdminDownloadResponseSuccess)

export const getTaskFailureCapsuleAdminDownloadUrl = (capsuleId: string,) => {




  return `/api/vektor/admin/task-capsules/${capsuleId}/download`
}

export const useTaskFailureCapsuleAdminDownloadHook = (): (capsuleId: string, options?: RequestInit) => Promise<taskFailureCapsuleAdminDownloadResponse> => {

      const customFetcher = useSfetchMutator();
      return (capsuleId: string, options?: RequestInit) => {

        return customFetcher(getTaskFailureCapsuleAdminDownloadUrl(capsuleId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


